import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import SaveIcon from '@material-ui/icons/Save';
import { Bar, Pie, Line } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import ReactToPdf from 'react-to-pdf';
import {
    IconButton,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    InputLabel
} from '@material-ui/core';
import { get_time_property, get_showrooms } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class ReportTimeProperty extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(0, 99, 132, 0.6)", "rgba(99, 132, 0, 0.6)", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];
        this.ref = React.createRef();
        this.state = {
            csv_output: [],
            start_print: false,
            redraw: false,
            table_data: [],
            raw_data: [],
            chartData: {},
            chart_option: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 10,
                            stepSize: 1
                        }
                    }]
                }
            },
            properties: [],
            values: {
                properties: "",
                appointment_type: "all",
                date_from: (moment().subtract(7, 'days').format('YYYY-MM-DD')),
                date_to: (moment().format('YYYY-MM-DD')),
            },
            doughnuts: [],
            rawReport: []
        };
        this.get_data();
        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let properties = await get_showrooms();
        if (properties) {
            currentObj.setState({
                ...this.state,
                properties: properties,
            }, () => {
                this.get_data();
            });
        }
    }
    parse_table_data(data) {
        var data_output = [];

        for (var i = 0; i < data.labels.length; i++) {
            var temp_row = [data.labels[i]];
            var row_total = 0;
            for (var j = 0; j < data.data.length; j++) {
                temp_row.push(data.data[j]['data'][i]);
                row_total += parseInt(data.data[j]['data'][i]);
            }
            temp_row.push(row_total);
            data_output.push(temp_row);
        }

        console.log(data_output);
        this.setState({
            ...this.state,
            table_data: data_output
        }, this.downloadCSV);
    }
    parse_chart_data(data) {
        var labels = data.labels;
        var datasets = [
        ];


        var doughnuts = [];
        var max_y_tick = 5;
        for (var i = 0; i < data.data.length; i++) {
            var ds = {
                label: data.data[i].name,
                backgroundColor: data.data[i].color,
                borderColor: data.data[i].color,
                borderWidth: 1,
                hoverBackgroundColor: data.data[i].color,
                hoverBorderColor: data.data[i].color,
                data: []
            };
            for (var j = 0; j < data.data[i].data.length; j++) {
                max_y_tick = max_y_tick > data.data[i].data[j] ? max_y_tick : parseInt(data.data[i].data[j]);
                ds.data.push(data.data[i].data[j]);
            }
            datasets.push(ds);
        }


        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets,
            },
            chart_option: {

                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: max_y_tick + 5,
                            stepSize: 1
                        }
                    }]
                }



            },
            rawReport: [],
            doughnuts: doughnuts
        });
    }
    async get_data() {
        var properties = this.state.values.properties;
        let property_arr = '';
        for (var i = 0; i < properties.length; i++) {
            if (i == 0) {
                property_arr += properties[i].property_id;
            } else {
                property_arr += ',' + properties[i].property_id;
            }

        }

        var data = await get_time_property({
            ...this.state.values,
            properties: property_arr,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD"),
        });
        if (data) {
            this.setState({
                ...this.state,
                raw_data: data.data.data
            });
            this.parse_table_data(data.data);
            this.parse_chart_data(data.data);
        }
    }

    handleChangeDate(date, field) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [field]: date
            }
        }, () => {
            this.get_data();
        });
    }
    downloadCSV() {
        var export_data = [];
        var header = [''];
        this.state.raw_data.map((row) => {
            header.push(row.name);
        });
        header.push('Total');
        export_data.push(header);

        this.state.table_data.map(row => {
            var data_row = [];
            row.map((cell) => {
                data_row.push(cell);
            });
            export_data.push(data_row);
        });
        this.setState({
            ...this.state,
            csv_output: export_data
        }, () => {
            console.log(this.state)
        }
        );
    }

    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Property_Bookings_Over_Time_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.85}
                                            x={1}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(toPdf, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Property_Bookings_Over_Time_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Property Bookings Over Time"
                            />
                            <Divider />
                            <CardContent class="report_container" className={useStyles.content}>
                                <div
                                    className="report_filter multiselect_reports"
                                >
                                    <div className="filter_field_wrapper">
                                        <Autocomplete
                                            // style={{
                                            //     flexGrow: 1,
                                            //     marginRight: 20
                                            // }}}
                                            multiple
                                            className="full_width"
                                            id="tags-standard"
                                            name="unit"
                                            options={this.state.properties}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, newVal) => {
                                                this.setState({
                                                    ...this.state,
                                                    values: {
                                                        ...this.state.values,
                                                        properties: newVal
                                                    }
                                                }, () => {
                                                    this.get_data();
                                                });
                                            }}
                                            renderInput={(params) => (

                                                <TextField
                                                    {...params}
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                    label="Property"
                                                    placeholder='select property'
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_from"
                                            label="From"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            className="full_width"
                                            type="date"
                                            name="date_to"
                                            label="to"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>
                                    {/* 
                                    <DatePicker
                                        style={{
                                            paddingTop: 16
                                        }}
                                        format="dd/MM/y"
                                        value={this.state.values.date_from}
                                        onChange={(date => this.handleChangeDate(date, 'date_from')).bind(this)}
                                        className="datepicker"
                                    ></DatePicker>
                                    <DatePicker
                                        style={{
                                            paddingTop: 16
                                        }}
                                        format="dd/MM/y"
                                        value={this.state.values.date_to}
                                        onChange={(date => this.handleChangeDate(date, 'date_to')).bind(this)}
                                        className="datepicker"
                                    ></DatePicker> */}

                                </div>
                                <div

                                    style={{
                                        width: this.state.start_print ? 900 : "auto"
                                    }}
                                    ref={this.ref}>
                                    {this.state.start_print && (
                                        <div style={{
                                            marginBottom: 30
                                        }}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <img src={require("../../assets/logo_small.png")}></img>
                                                    <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                <Grid item md={6} style={{
                                                    textAlign: 'center'
                                                }}>
                                                    <h1>Property Bookings Over Time</h1>
                                                </Grid>
                                            </Grid>

                                        </div>
                                    )}
                                    <div style={{
                                        height: '60vh',
                                        maxHeight: '20vh'
                                    }}>
                                        <Bar
                                            width={this.state.start_print ? 900 : 'auto'}
                                            redraw={this.state.redraw}
                                            options={{
                                                ...this.state.chart_option,
                                                maintainAspectRatio: false,
                                                devicePixelRatio: 4
                                            }} data={this.state.chartData}></Bar>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <Table className=" report_table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell style={{
                                                    textAlign: "center",
                                                    backgroundColor: "black",
                                                    color: "white"
                                                }}></TableCell>
                                                <TableCell style={{
                                                    textAlign: "center",
                                                    backgroundColor: "black",
                                                    color: "white"
                                                }}
                                                    colSpan={this.state.raw_data.length + 2}>Appointments</TableCell>

                                            </TableRow>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                {this.state.raw_data.map(row => (
                                                    <TableCell>{row.name}</TableCell>
                                                ))}

                                                <TableCell
                                                    className="bold section_2"
                                                >Total</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.table_data.map((row) => (
                                                <TableRow>
                                                    {row.map((cell) => (
                                                        <TableCell>{cell}</TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                                {/* <Table className="hide_mobile report_table">
                                    <TableHead>
                                        <TableRow >
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}></TableCell>
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}
                                                colSpan={4}>Appointments</TableCell>
                                            <TableCell
                                                style={{
                                                    textAlign: "center",
                                                    backgroundColor: "black",
                                                    color: "white"
                                                }}
                                                colSpan={4}>Guests</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell
                                            >Arrived</TableCell>
                                            <TableCell>No Show</TableCell>
                                            <TableCell>Booked</TableCell>
                                            <TableCell
                                                className="bold"
                                            >Total</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >Arrived</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >No Show</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >Booked</TableCell>
                                            <TableCell
                                                className="bold section_2"
                                            >Total</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.state.rawReport.map((row) => (
                                            <TableRow>
                                                <TableCell className="bold">{row.agency}</TableCell>
                                                <TableCell>{row.arrived}</TableCell>
                                                <TableCell>{row.no_show}</TableCell>
                                                <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                <TableCell className="bold">{row.total}</TableCell>
                                                <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                <Table className="hide_desktop report_table">
                                    <TableHead>
                                        <TableRow >
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}></TableCell>
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}
                                                colSpan={4}>Appointments</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell
                                            >Arrived</TableCell>
                                            <TableCell>No Show</TableCell>
                                            <TableCell>Booked</TableCell>
                                            <TableCell
                                                className="bold"
                                            >Total</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.state.rawReport.map((row) => (
                                            <TableRow>
                                                <TableCell className="bold">{row.agency}</TableCell>
                                                <TableCell>{row.arrived}</TableCell>
                                                <TableCell>{row.no_show}</TableCell>
                                                <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                <TableCell className="bold">{row.total}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <Table className="hide_desktop report_table">
                                    <TableHead>
                                        <TableRow >
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}></TableCell>
                                            <TableCell
                                                style={{
                                                    textAlign: "center",
                                                    backgroundColor: "black",
                                                    color: "white"
                                                }}
                                                colSpan={4}>Guests</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>

                                            <TableCell
                                                className="section_2"
                                            >Arrived</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >No Show</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >Booked</TableCell>
                                            <TableCell
                                                className="bold section_2"
                                            >Total</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.state.rawReport.map((row) => (
                                            <TableRow>
                                                <TableCell className="bold">{row.agency}</TableCell>

                                                <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table> */}

                                <br></br>
                                <br></br>
                                <Grid container>
                                    {this.state.doughnuts.map(doughnut => (
                                        <Grid md={4}>
                                            <h3>{doughnut.title}</h3>
                                            <hr></hr>
                                            <Pie data={doughnut}></Pie>
                                        </Grid>
                                    ))}

                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment >
        )
    }
}
